import { ClusterLayer, VectorLayer } from '@datum-group/datum-map/lib';
import { computed, makeObservable, observable, runInAction } from 'mobx';
import { serializeFilters } from '../../components/Module/Table/Filters/FilterInput/utils';
import { MapStore } from '../Map';
import { APITableLayer } from '../shared/RecordCard/types';
import { TableAPIController } from '../Table/Table';

export class LayerFilterController {
  private _apiLayer: APITableLayer;
  private _map: MapStore;

  readonly tableController: TableAPIController;

  @observable private _count?: number = undefined;

  constructor(
    map: MapStore,
    tableController: TableAPIController,
    apiLayer: APITableLayer,
  ) {
    this._map = map;
    this._apiLayer = apiLayer;
    this.tableController = tableController;

    makeObservable(this);
  }

  /** Количество отфильтрованных записей */
  @computed get count() {
    return this._count;
  }

  removeFilter = () => {
    const layer = this._getLayer(this._apiLayer.layer_name);

    if (layer) {
      const currentParams = layer.objectManager.parameterManager.params;

      layer.objectManager.parameterManager.multipleDelete(
        new Set(Object.keys(currentParams)),
      );
    }

    runInAction(() => {
      this._count = undefined;
    });
  };

  setFilter = () => {
    const layer = this._addLayer(this._apiLayer.layer_name);

    const table = this.tableController.table;

    if (layer) {
      const currentParams = layer.objectManager.parameterManager.params;

      const newParams = serializeFilters(
        table.columns,
        table.query.filterFields,
      );

      layer.objectManager.parameterManager.mixedChange({
        set: newParams,
        delete: new Set(Object.keys(currentParams)),
      });
    }

    runInAction(() => {
      this._count = table.total;
    });
  };

  private _getLayer = (layerName: string) => {
    const layerCollection = this._map.layerCollection;

    const datumLayer = layerCollection.getLayer(layerName);

    if (datumLayer) {
      if (
        !(
          datumLayer instanceof VectorLayer ||
          datumLayer instanceof ClusterLayer
        )
      ) {
        throw new Error(`Невалидный тип слоя ${layerName}`);
      }

      return datumLayer;
    }

    return null;
  };

  private _addLayer(layerName: string) {
    const datumLayer = this._getLayer(layerName);

    if (datumLayer) {
      return datumLayer;
    }

    const layerCollection = this._map.layerCollection;

    const layer = layerCollection.add(this._apiLayer);

    if (!(layer instanceof VectorLayer || layer instanceof ClusterLayer)) {
      layerCollection.remove(layerName);

      throw new Error(`Невалидный тип слоя ${layerName}`);
    }

    return layer;
  }
}
